import React, { useState, useEffect, useRef } from "react";

import "../../css/MessageBTNMobile.css";

import chat_icon from "../../assets/chat.png";
import close_icon from "../../assets/close.png";

const MessageBTNMobile = (props) => {
  const [openMessage, setOpenMessage] = useState(false);

  useEffect(() => {
    const metaTag = document.createElement('meta');
    metaTag.name = 'viewport';
    metaTag.content = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no';
    document.head.appendChild(metaTag);

    return () => {
      document.head.removeChild(metaTag);
    };
  }, []);

  return (
    <>
      <div className="container-message-btn-mb">
        <div className="chat-icon" onClick={() => setOpenMessage(!openMessage)}>
          <div style={{ backgroundColor: "rgba(232, 222, 248, 1)", borderRadius: "100px", padding: "12px" }}>
            <img src={chat_icon} style={{ width: "28px", height: "28px" }}></img>
          </div>
        </div>
      </div>

      <div className="container-message-chat-mb" style={ openMessage ? {position: "fixed"}:{}}>
        {openMessage ? (
          <div className="hover-message-mb">
            <div className="message-iframe-close-container" onClick={() => setOpenMessage(!openMessage)}>
                {/* <img style={{ width: "40px", height: "40px", marginTop: "8px", marginRight: "8px" }} src={close_icon}></img> */}
                <div style={{ marginTop: "4px", marginLeft: "4px", backgroundColor: "rgba(232, 222, 248, 1)", borderRadius: "100px", padding: "10px" }}>
                  <svg 
                    width="28px" 
                    height="28px" 
                    version="1.1" 
                    id="fi_507257" 
                    xmlns="http://www.w3.org/2000/svg" 
                    x="0px" 
                    y="0px" 
                    viewBox="0 0 447.243 447.243"
                  >
                    <g>
                      <g>
                        <path d="M420.361,192.229c-1.83-0.297-3.682-0.434-5.535-0.41H99.305l6.88-3.2c6.725-3.183,12.843-7.515,18.08-12.8l88.48-88.48
                                  c11.653-11.124,13.611-29.019,4.64-42.4c-10.441-14.259-30.464-17.355-44.724-6.914c-1.152,0.844-2.247,1.764-3.276,2.754
                                  l-160,160C-3.119,213.269-3.13,233.53,9.36,246.034c0.008,0.008,0.017,0.017,0.025,0.025l160,160
                                  c12.514,12.479,32.775,12.451,45.255-0.063c0.982-0.985,1.899-2.033,2.745-3.137c8.971-13.381,7.013-31.276-4.64-42.4
                                  l-88.32-88.64c-4.695-4.7-10.093-8.641-16-11.68l-9.6-4.32h314.24c16.347,0.607,30.689-10.812,33.76-26.88
                                  C449.654,211.494,437.806,195.059,420.361,192.229z"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </div>
            </div>
            <iframe className="message-iframe-container" src={`https://chat.traffy.in.th/?version=${Math.floor(Math.random() * 100000) + 1}&messageID=${props?.data?.message_id}&bypassLineAuth=true&ticketID=${props?.data?.ticket_id}&lang=${props?.data?.lang}`} title="Talk to a staff">
            </iframe>
            {/* <iframe className="message-iframe-container" src={`http://localhost:5173/?version=${Math.floor(Math.random() * 100000) + 1}&messageID=${props?.data?.message_id}&bypassLineAuth=true&ticketID=${props?.data?.ticket_id}&lang=${props?.data?.lang}`} title="Talk to a staff">
            </iframe> */}
          </div>
        ) : (
            null
        )}
      </div>
    </>
  );
};

export default MessageBTNMobile;
